import {storeObservable, TStoreId} from "./sessionstore";
import {nsAmplify} from "./nsAmplify";

export class Toggle {
    isToggled: KnockoutObservable<boolean>;
    private toggleSubscription: KnockoutSubscription;

    constructor(private storeId: TStoreId, defaultValue: boolean) {
        this.isToggled = storeObservable(storeId, defaultValue);
        this.toggleSubscription = this.isToggled.subscribe(() => {
            nsAmplify.store(storeId, this.isToggled());
        });
    }

    toggle() {
        this.isToggled(!this.isToggled());
    }

    getStoreId(): string {
        return this.storeId;
    }

    dispose() {
        this.toggleSubscription.dispose();
    }
}
